export const QK_TOOLKIT = '/settings/how-to-use-toolkit';
